import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/success.png'
import _imports_1 from '@/assets/error.png'


const _withScopeId = n => (_pushScopeId("data-v-a36e3ec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center flex-column align-items-center mt-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "success"
}, null, -1))
const _hoisted_3 = { class: "fs-2 fw-bolder text-success" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "fail"
}, null, -1))
const _hoisted_5 = { class: "fs-2 fw-bolder text-danger" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center mb-5" }
const _hoisted_8 = {
  key: 1,
  class: "text-center mb-5"
}
const _hoisted_9 = {
  key: 2,
  class: "error-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDButton = _resolveComponent("VDButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    draggable: false,
    visible: $setup.isVisible,
    modal: true,
    style: { width: '50vw' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($setup.isSuccess)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_2,
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("TextResources_Success")), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_4,
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("TextResources_Error")), 1)
            ], 64))
      ]),
      ($setup.modalType == $setup.modalTypes.CREATE_USER_ONBOARD_STATUS && $setup.isSuccess && $setup.canLinkNemLogin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("TextResources_LinkToNemLoginQuestion")), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_VDButton, { onClick: $setup.action }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("TextResources_LinkToNemLoginAction")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ], 64))
        : ($setup.modalType == $setup.modalTypes.LINK_TO_MIT_ID_STATUS && $setup.isSuccess)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t("TextResources_LinkToNemLoginSuccess")), 1))
          : _createCommentVNode("", true),
      (!$setup.isSuccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.errorMessage), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["visible"]))
}